<template>
  <div class="overlay" @click="closeModal">
    <div v-if="formWasSent === 0" @click.stop class="modal-grid">
      <div class="full-width">
        <div class="modal-close" @click="closeModal">
          <object type="image/svg+xml" data="/assets/icons/close.svg"></object>
        </div>
        <h1>{{ text['0024'] }}</h1>
      </div>
      <div>
        <input type="text" name="last-name" :placeholder="`${text['0025']}*`" v-model="formLastName">
        <span class="form-error" v-if="emailFormData.lastName.error !== ''">{{ emailFormData.lastName.error }}</span>
      </div>
      <div>
        <input type="text" name="first-name" :placeholder="`${text['0026']}*`" v-model="formFirstName">
        <span class="form-error" v-if="emailFormData.firstName.error !== ''">{{ emailFormData.firstName.error }}</span>
      </div>
      <div class="full-width">
        <input type="text" name="company" :placeholder="`${text['0027']}*`" v-model="formCompany">
        <span class="form-error" v-if="emailFormData.company.error !== ''">{{ emailFormData.company.error }}</span>
      </div>
      <div class="full-width">
        <input type="email" name="email" :placeholder="`${text['0028']}*`" v-model="formEmail">
        <span class="form-error" v-if="emailFormData.email.error !== ''">{{ emailFormData.email.error }}</span>
      </div>
      <div class="full-width">
        <input type="checkbox" name="email-use" id="allow-use" v-model="formAllowUse">
        <label for="allow-use">{{ text['0033'] }}</label>
      </div>
      <div class="full-width">
        <button class="navigation secondary" @click="submitEmailForm">{{ text['0029'] }}</button>
      </div>
    </div>
    <div v-else @click.stop class="modal-grid">
      <div class="full-width">
        <div class="modal-close" @click="closeModal">
          <object type="image/svg+xml" data="/assets/icons/close.svg"></object>
        </div>
      </div>
      <div class="full-width confirmation">
        {{ confirmationMessage }}
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { mapActions } from 'vuex';

  export default {
    computed: {
      ...mapGetters({
        text: 'getText',
        emailFormData: 'getEmailFormData',
        formWasSent: 'getEmailFormSentStatus',
      }),
      confirmationMessage() {
        return this.text['0034'].replace('[email]',this.emailFormData.email.value);
      },
      formLastName: {
        get () {
          return this.emailFormData.lastName.value;
        },
        set (value) {
          const payload = { field: 'lastName', value: value };
          this.setEmailFormData(payload);
        }
      },
      formFirstName: {
        get () {
          return this.emailFormData.firstName.value;
        },
        set (value) {
          const payload = { field: 'firstName', value: value };
          this.setEmailFormData(payload);
        }
      },
      formCompany: {
        get () {
          return this.emailFormData.company.value;
        },
        set (value) {
          const payload = { field: 'company', value: value };
          this.setEmailFormData(payload);
        }
      },
      formEmail: {
        get () {
          return this.emailFormData.email.value;
        },
        set (value) {
          const payload = { field: 'email', value: value };
          this.setEmailFormData(payload);
        }
      },
      formAllowUse: {
        get () {
          return this.emailFormData.allowUse.value;
        },
        set (value) {
          const payload = { field: 'allowUse', value: value };
          this.setEmailFormData(payload);
        }
      },
    },
    methods: {
      ...mapActions({
        closeModal: 'navigation/closeModal',
        setEmailFormData: 'setEmailFormData',
        submitEmailForm: 'submitEmailForm',
      }),
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/screens/EmailModal.vue